/**
 * Staging Environment Configuration
 * Tree-shaken out when TARGET_FIREBASE !== 'staging'
 */

import { AppConfig } from './types';
import { matterport, sentrySha } from './config.common';

const staging: AppConfig = {
	deployment: 'staging',
	containerized: false,
	autofill_forms: true,

	// ??? firestore says that the sparkplan has cloud functions,
	// but the web interface says to upgrade the plan?
	apiHost: 'https://us-central1-threedres-staging.cloudfunctions.net',
	cdnHost: 'https://cdn.tablz.net/',
	adminApiHost: 'https://api.staging.tablz.com/portal',
	firebase: {
		apiKey: process.env.FIREBASE_API_KEY || '',
		authDomain: 'threedres-staging.firebaseapp.com',
		projectId: 'threedres-staging',
		storageBucket: 'cdn-staging.tablz.net',
		messagingSenderId: '436872751445',
		appId: '1:436872751445:web:cee7e083a24d81881127dc',
		measurementId: 'G-D7JN6JKC1B',
		longPolling: false,
		emulators: {
			firestore: null,
			storage: null,
			auth: null
		}
	},
	sentry: {
		enable: true,
		dsn: 'https://005332b19583451ea4a15adbe708308a@o301373.ingest.sentry.io/5683407',
		environment: 'staging',
		enableTracing: false,
		denyUrls: sentrySha.denyUrls,
		ignoreErrors: sentrySha.ignoreErrors,
		debug: true
	},
	analytics: {
		mixpanel: {
			token: '9f8400e49c74aef49bc4aedc7222a0c4',
			enable: false, // set true to resume sending events to Mixpanel
			config: {
				debug: true
			}
		},
		enable: true // Completely disable analytics
	},
	matterport: {
		...matterport,
		assetOrigin: 'https://app.staging.tablz.com'
	},
	stripe: {
		can: {
			pub_key: 'pk_test_51IxNyBAGhKmUXc8yzEHo9jCOCEddt39dsjl9W9NJj3r79CXftv3uQppfa6cdFf9bVTZ2PcHlN7aBG73pjYowWQ7q00P6hxUkFL'
		},
		usa: {
			pub_key: 'pk_test_51JtkHqAy16LJuVrBr8GXjzIAlcT1ntnf9SCYRAbsDnaaqZPfer9WxW7l4z6d6vaLRuCZVYoqfFWxcs4ccvSyJ4Ay00B963vcWv'
		}
	},
	statsig: {
		sdkKey: 'client-lhDp8TrrEdtaMvgGkEhGBDNwMsHuyQBsBfaaUdpFVbD',
		tier: 'staging'
	},
	gtm: {
		platformWebContainerId: 'GTM-TQ6HLFMV', // Tablz Web Container
		tagGatewayPath: '/uwr8'
	}
};

export default staging;
